/**
 * Hands a prompt to the chat composer (#1826). In memory on purpose: window
 * params would put the text into the deep link and make the chat a second
 * window. A chat that is still opening picks the prompt up when it mounts.
 */

interface PendingPrompt {
  text: string
  /** The chat window meant; undefined means the first chat that listens. */
  target?: string
}

type Listener = () => void

let pending: PendingPrompt | null = null
const listeners = new Set<Listener>()

export function offerPromptToChat(text: string, target?: string): void {
  pending = { text, target }
  listeners.forEach((listener) => listener())
}

/** The waiting prompt, once, if it is meant for this chat. */
export function takePromptForChat(instanceId: string | undefined): string | null {
  if (!pending || (pending.target && pending.target !== instanceId)) return null
  const { text } = pending
  pending = null
  return text
}

export function subscribeToPromptOffers(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
